export const customRoutes = [
];



// WEBPACK FOOTER //
// ./src/routes.js